import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'categories',
  initialState: {
    items: {},
  },
  reducers: {
    update(state, action) {
      action.payload.forEach((item) => state.items[item.name] = item);
    },
  },
});

export { actions as categoriesActions };
export { reducer as categoriesReducer };
